import { ShiftBlock } from '../fetching/sharedSchemas/misc';

export const getShiftBlockInstanceId = (shiftBlock: ShiftBlock) => {
    return `${shiftBlock.uuid}-${shiftBlock.qhp.uuid}`;
};

export const getShiftBlockInstanceLabel = (shiftBlock: ShiftBlock) => {
    return shiftBlock.notes === ''
        ? shiftBlock.clinicians.length === 1 && shiftBlock.clinician_teams.length === 0
            ? `Shift Block for ${shiftBlock.qhp.name}`
            : 'Shift Block for multiple clinicians'
        : shiftBlock.notes;
};
